<div class="row" *ngIf="jobs">
  <div translate class="col-2">
    JOBS.ADD_NEW
    <div *ngFor="let cur of fourD.jobTypes">
      <button (click)="addNew(cur)"> {{ 'GENERIC.ADD' | translate }} {{ cur.name }}</button>
    </div>

    JOBS.EXISTING

    <div *ngFor="let cur of jobs.items | async">
      <button (click)="selectedJob = cur">{{ cur.name }}</button>
    </div>

  </div>
  <div class="col-10">
    <job-details [job]="selectedJob" *ngIf="selectedJob"></job-details>
  </div>



</div>
